import { CommonModule, NgClass } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Utils } from 'app/common/utils';

/** Valor de cierre para la opción "Todas las Empresas". */
export const DOM_EMP_TODAS = -1;

export interface DomEmpSelectorData {
    empresas: { id: number; name: string; rutt: string }[];
    /** kemp marcado como actual, o DOM_EMP_TODAS si se está en el tablero consolidado. */
    actual: number;
}

/**
 * Monoselector del botón Dominio (usuario tipo DOM), en 2 secciones:
 * 1) botón Holding (→ DOM_EMP_TODAS, ger/dbg-hol); 2) grid con las empresas
 * del dominio. Un click elige y cierra (sin Aceptar): devuelve
 * el kemp elegido, DOM_EMP_TODAS, o undefined si se cancela.
 */
@Component({
    selector: 'dom-emp-selector',
    templateUrl: './dom-emp.selector.html',
    styles: [`
        .dom-emp-grid { grid-template-columns: 120px auto 60px; }
    `],
    imports: [
        CommonModule, NgClass,
        MatDialogTitle, MatDialogContent, MatDialogClose,
        MatButtonModule, MatIconModule, MatTooltipModule,
    ],
})
export class DomEmpSelector {
    readonly TODAS = DOM_EMP_TODAS;

    constructor(
        public dialogRef: MatDialogRef<DomEmpSelector>,
        @Inject(MAT_DIALOG_DATA) public data: DomEmpSelectorData,
        public utils: Utils,
    ) {
        this.dialogRef.updateSize('820px', 'auto');
        this.dialogRef.addPanelClass(['dom-emp-selector-modal', 'amz-selector-modal']);
    }

    select(id: number): void {
        this.dialogRef.close(id);
    }
}
